import Accordion from './accordion.class'

// Debounce helper function
function debounce(func, wait) {
  let timeout
  return function(...args) {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.apply(context, args)
    }, wait)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // #region Accordion Setup
  document.querySelectorAll('.nxt-accordion-item').forEach(el => {
    new Accordion(el)
  })
  // #endregion

  // #region FAQ Search AJAX
  const searchForm = document.getElementById('nxt-faq-search-form')
  if (searchForm) {
    const resultsContainer = document.getElementById('nxt-faq-search-results')
    const searchInput = searchForm.querySelector('.nxt-accordion-search-input')
    const searchButton = searchForm.querySelector('.nxt-accordion-search-button')
    
    // Function to perform the search
    const performSearch = () => {
      // Get search term
      const searchTerm = searchInput.value.trim()
      
      if (!searchTerm) {
        resultsContainer.innerHTML = ''
        return
      }
      
      // Check minimum length
      if (searchTerm.length < 3) {
        resultsContainer.innerHTML = `<p>${wp.i18n.__('Please enter at least 3 characters', 'nxt-faq-accordion')}</p>`
        return
      }
      
      // Show loading state with throbber
      searchButton.disabled = true
      resultsContainer.innerHTML = `<div class="nxt-faq-search-throbber">
        <div class="nxt-faq-search-spinner"></div>
      </div>`
      
      // Send AJAX request
      const data = new FormData()
      data.append('action', 'nxt_faq_search_ajax')
      data.append('faq_search', searchTerm)
      
      fetch(nxtFaqData.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        body: data
      })
      .then(response => response.json())
      .then(data => {
        // Reset button state
        searchButton.disabled = false
        
        if (data.success) {
          // Display results
          const output = data.data.output
          resultsContainer.innerHTML = output
          
          // Initialize accordion for the new items
          resultsContainer.querySelectorAll('.nxt-accordion-item').forEach(el => {
            new Accordion(el)
          })
          
        } else {
          // Display error
          resultsContainer.innerHTML = `<p class="nxt-faq-search-error">${data.data.message}</p>`
        }
      })
      .catch(error => {
        searchButton.disabled = false
        resultsContainer.innerHTML = `<p class="nxt-faq-search-error">${wp.i18n.__('Error performing search. Please try again.', 'nxt-faq-accordion')}</p>`
        console.error('FAQ Search Error:', error)
      })
    }
    
    // Create debounced version of search function (500ms delay)
    const debouncedSearch = debounce(performSearch, 500)
    
    // Add input event listener with debounce
    searchInput.addEventListener('input', debouncedSearch)
    
    // Keep the original form submit handler
    searchForm.addEventListener('submit', function(e) {
      e.preventDefault()
      performSearch()
    })
  }
  // #endregion
})

document.addEventListener('DOMContentLoaded', function () {
  const faqWrapper = document.querySelector('.nxt-faq-accordion-wrapper')

  if (!faqWrapper) {
    return // Early return if the FAQ wrapper is not present
  }

  const showAttribute = faqWrapper.getAttribute('data-show')
  const faqItems = faqWrapper.querySelectorAll('.nxt-accordion-item')
  const showButton = document.createElement('button')
  showButton.innerText = wp.i18n.__('Show more', 'nxt-faq-accordion')
  showButton.style.display = 'none'
  showButton.classList.add('nxt-accordion-show-more')

  if (showAttribute && !isNaN(showAttribute)) {
    const numberOfItemsToShow = parseInt(showAttribute, 10)
    if (numberOfItemsToShow < faqItems.length) {
      for (let i = numberOfItemsToShow; i < faqItems.length; i++) {
        faqItems[i].style.display = 'none'
      }
      showButton.style.display = 'block'
    }
  }

  showButton.addEventListener('click', function () {
    const isShowingAll =
      showButton.innerText === wp.i18n.__('Show less', 'nxt-faq-accordion')
    const numberOfItemsToShow = parseInt(showAttribute, 10)
    for (let i = 0; i < faqItems.length; i++) {
      if (i >= numberOfItemsToShow) {
        faqItems[i].style.display = isShowingAll ? 'none' : ''
      }
    }
    showButton.innerText = isShowingAll
      ? wp.i18n.__('Show more', 'nxt-faq-accordion')
      : wp.i18n.__('Show less', 'nxt-faq-accordion')
  })

  faqWrapper.appendChild(showButton)
})
